import React from 'react';

import BrandCategorySolidIcon from '../../../../shared/icons/brand-category-solid-icon';
import CarAltSolidIcon from '../../../../shared/icons/car-alt-solid-icon';
import TireSolidIcon from '../../../../shared/icons/tire-solid-icon';
import Typography from '../../../typography/typography';
import { TABS } from '../../fitment-constants';
import FitmentShopByButton from '../fitment-shop-by-button/fitment-shop-by-button';

import './fitment-shop-by.scss';

interface FitmentShopByProps {
  onClick: (tab: string) => void;
}

function FitmentShopBy(props: FitmentShopByProps) {
  const { onClick } = props;

  return (
    <div styleName="container">
      <Typography className="fitment-title" variant="H3">
        Shop by
      </Typography>
      <FitmentShopByButton
        icon={CarAltSolidIcon}
        onClick={onClick}
        tab={TABS.VEHICLE}
      />
      <FitmentShopByButton
        icon={TireSolidIcon}
        onClick={onClick}
        tab={TABS.SIZE}
      />
      <FitmentShopByButton
        icon={BrandCategorySolidIcon}
        onClick={onClick}
        tab={TABS.BRAND}
      />
    </div>
  );
}

export default FitmentShopBy;
